import { CheckCircle, XCircle } from 'lucide-react';

interface ResultsHeroProps {
  passed: boolean;
  correct: number;
  total: number;
}

export default function ResultsHero({
  passed,
  correct,
  total,
}: ResultsHeroProps) {
  const subtitle = passed
    ? `You answered ${correct} of ${total} correctly. Great work.`
    : `You answered ${correct} of ${total}. Here's where to focus next.`;

  return (
    <div className="flex flex-col items-center text-center">
      <div
        className={`w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-5 ${
          passed ? 'bg-success/15' : 'bg-warning/15'
        }`}
      >
        {passed ? (
          <CheckCircle size={30} className="text-success" />
        ) : (
          <XCircle size={30} className="text-warning" />
        )}
      </div>
      <h1 className="font-display font-semibold text-2xl md:text-3xl lg:text-4xl text-text-primary mb-2">
        {passed ? 'You passed!' : 'Keep practicing'}
      </h1>
      <p className="font-sans text-sm md:text-base text-text-secondary max-w-md">
        {subtitle}
      </p>
    </div>
  );
}
